export default __webpack_public_path__ + "static/tea3-6e0d6dd0b923f60d142983986ffb748d.png";